import { combineReducers } from '@reduxjs/toolkit';
import { googlePayOptionsReducer } from './options';
import { googlePayButtonReducer } from './button';
import { googlePayPaymentDataReducer } from './paymentData';

export { googlePayOptionsInitialState } from './options';
export { googlePayButtonInitialState } from './button';
export { googlePayPaymentDataInitialState } from './paymentData';

export const googlePayReducer = combineReducers({
  options: googlePayOptionsReducer,
  button: googlePayButtonReducer,
  paymentData: googlePayPaymentDataReducer,
});
